// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-modal .ant-modal-body {
	padding: 0px 0px 0px 32px !important;
}

.user-select-style {
	height: 35px;
	width: 200px !important;
	margin-top: 32px;
}

.app-user-max-height {
	max-height: 530px;
}

.input-con-all-user {
	width: 450px !important;
}

.user-top-account {
	font-family:
		Segoe UI,
		sans-serif;
	font-weight: 600;
	font-style: Semibold;
	font-size: 14px;
	line-height: 100%;
	letter-spacing: 0px;
	vertical-align: middle;
	margin-top: -16px;
	margin-bottom: 24px;
	color: #3b3b3b;
}

.user-top-account-name {
	font-weight: 400;
	font-style: Regular;
	color: #707070;
}

.input-con-all-user .ant-select-selector {
	max-height: 155px !important;
	overflow-y: auto !important;
	min-height: 34px !important;
	border-radius: 4px !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/permission/user/index.css"],"names":[],"mappings":"AAAA;CACC,oCAAoC;AACrC;;AAEA;CACC,YAAY;CACZ,uBAAuB;CACvB,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC;;YAEW;CACX,gBAAgB;CAChB,oBAAoB;CACpB,eAAe;CACf,iBAAiB;CACjB,mBAAmB;CACnB,sBAAsB;CACtB,iBAAiB;CACjB,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,4BAA4B;CAC5B,2BAA2B;CAC3B,2BAA2B;CAC3B,6BAA6B;AAC9B","sourcesContent":[".ant-modal .ant-modal-body {\n\tpadding: 0px 0px 0px 32px !important;\n}\n\n.user-select-style {\n\theight: 35px;\n\twidth: 200px !important;\n\tmargin-top: 32px;\n}\n\n.app-user-max-height {\n\tmax-height: 530px;\n}\n\n.input-con-all-user {\n\twidth: 450px !important;\n}\n\n.user-top-account {\n\tfont-family:\n\t\tSegoe UI,\n\t\tsans-serif;\n\tfont-weight: 600;\n\tfont-style: Semibold;\n\tfont-size: 14px;\n\tline-height: 100%;\n\tletter-spacing: 0px;\n\tvertical-align: middle;\n\tmargin-top: -16px;\n\tmargin-bottom: 24px;\n\tcolor: #3b3b3b;\n}\n\n.user-top-account-name {\n\tfont-weight: 400;\n\tfont-style: Regular;\n\tcolor: #707070;\n}\n\n.input-con-all-user .ant-select-selector {\n\tmax-height: 155px !important;\n\toverflow-y: auto !important;\n\tmin-height: 34px !important;\n\tborder-radius: 4px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
